import { Button } from 'components/shared';
import React, { useState } from 'react';
import { errorNotification, throwSubmissionError } from 'utils';
import { usePayPalCardFields } from '@paypal/react-paypal-js';
import { useForm } from 'react-final-form';
import PropTypes from 'prop-types';

const fieldNameMap = {
  cardNameField: 'appraisalPayment.creditCard.nameOnCard',
  cardNumberField: 'appraisalPayment.creditCard.number',
  cardExpiryField: 'appraisalPayment.creditCard.expiryDate',
  cardCvvField: 'appraisalPayment.creditCard.verificationValue',
};

const SubmitPayment = ({ input }) => {
  const [paying, setPaying] = useState(false);
  const { cardFieldsForm } = usePayPalCardFields();
  const form = useForm();

  const handleClick = async () => {
    if (!cardFieldsForm) {
      throw new Error(
        'Unable to find any child components in the <PayPalCardFieldsProvider />',
      );
    }

    await form.submit();
    await new Promise((resolve) => setTimeout(resolve, 0));

    const updatedFormState = form.getState();
    const formState = await cardFieldsForm.getState();

    if (
      updatedFormState.invalid ||
      !formState.isFormValid ||
      Object.keys(updatedFormState.errors || {}).length > 0
    ) {
      Object.entries(formState.fields || {}).forEach(([fieldName, field]) => {
        if (field.isEmpty) {
          form.change(fieldNameMap[fieldName], 'empty');
        }
      });

      throwSubmissionError(updatedFormState.errors || {});

      return;
    }

    setPaying(true);

    try {
      await cardFieldsForm.submit();
    } catch (error) {
      errorNotification('Payment submission failed');
    } finally {
      setPaying(false);
    }
  };

  return (
    <Button onClick={handleClick} rounded disabled={paying}>
      {paying ? 'Please wait…' : `Pay $${input.value}`}
    </Button>
  );
};

SubmitPayment.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  setSuccessTrue: PropTypes.func.isRequired,
};

export default SubmitPayment;
